import React, { useEffect, useRef } from "react";
const TradingViewWidget = ({ symbol, type }) => {
  const containerRef = useRef(null);
  useEffect(() => {
    if (!containerRef.current) return;
    if(containerRef.current.innerHTML !== ""){
      containerRef.current.innerHTML = ""
    }
    try {
      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
      script.type = "text/javascript";
      script.async = true;
      let symbolPrefix = "";
      if (type === "crypto") {
        symbolPrefix = "CRYPTOCAP:";
      } else if (type === "stock") {
        symbolPrefix = "NASDAQ:";
      } else if (type === "forex") {
        symbolPrefix = "FX:";
      }
      script.innerHTML = JSON.stringify({
        width: "100%",
        height: "600",
        symbol: `${symbolPrefix}${symbol}${symbolPrefix === "FX:"?"USD":""}`,
        interval: "D",
        theme: "dark",
        style: "1",
        locale: "en",
        hide_top_toolbar: true,
        allow_symbol_change: true,
        save_image: false,
        support_host: "https://www.tradingview.com",
      });
      containerRef.current.appendChild(script);
    } catch (err) {
      console.error("TradingView widget load error:", err);
    }
  }, [symbol, type]);
  return <div ref={containerRef} />;
};
export default TradingViewWidget;